import { useQuery } from 'react-query';
import { api } from '../api';
import { RssSite, RssSitePageData, RssFeedPageData, RssItem, RssItemPageData, ApiResponse } from '../types';

const DATA_REFRESH_TIME = 1000 * 30; // 30 seconds
const DATA_CACHE_TIME = 1000 * 60 * 60; // 1 hour

const queryConfig = {
  cacheTime: DATA_CACHE_TIME,
  refetchInterval: DATA_REFRESH_TIME,
  refetchOnWindowFocus: true,
  onError: (err: any) => console.log(err),
};

export const useHomepage = () => {
  return useQuery<ApiResponse<RssSite[]>>(['homepage'], api.getHomepageItems);
};

export const useSite = (siteId: number) =>
  useQuery<ApiResponse<RssSitePageData>>(['site', siteId], () => api.getSiteItems(siteId), {
    ...queryConfig,
    enabled: !!siteId,
  });

export const useFeed = (feedId: number) =>
  useQuery<ApiResponse<RssFeedPageData>>(['feed', feedId], () => api.getFeedItems(feedId), {
    ...queryConfig,
    enabled: !!feedId,
  });

export const useLatestItems = () =>
  useQuery<ApiResponse<RssItem[]>>(['latest'], api.getLatestItems, queryConfig);

export const useItem = (itemId: number) =>
  useQuery<ApiResponse<RssItemPageData>>(['item', itemId], () => api.getItem(itemId), {
    enabled: !!itemId,
  });
